module.exports = __webpack_public_path__ + "static/img/8.2cff316.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/eng/8.png
// module id = rmSR
// module chunks = 0